"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const actionTypes_1 = require("./actionTypes");
const sliceReducer = (state = {}, action) => {
    switch (action.type) {
        case actionTypes_1.CACHE_DOCUMENTS: {
            const { docs, isPartial } = action;
            const newState = Object.assign({}, state);
            for (let doc of docs) {
                const existingDoc = newState[doc._id] || {};
                const mergedDoc = isPartial ? Object.assign(Object.assign({}, existingDoc), doc) : doc;
                newState[doc._id] = mergedDoc;
            }
            return newState;
        }
        case actionTypes_1.UNCACHE_DOCUMENTS: {
            const { docs } = action;
            const newState = Object.assign({}, state);
            for (let doc of docs) {
                newState[doc._id] = undefined;
            }
            return newState;
        }
        case actionTypes_1.CLEAR_DOCUMENTS: {
            return {};
        }
        default:
            return null;
    }
};
const documentCacheReducer = (state = {}, action) => {
    const { slice } = action, sliceAction = __rest(action, ["slice"]);
    if (!slice)
        return state;
    const newState = Object.assign({}, state);
    const newSliceState = sliceReducer(newState[slice], sliceAction);
    if (newSliceState)
        newState[slice] = newSliceState;
    return newState;
};
exports.default = documentCacheReducer;
